import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import MasterDataTemplateEditor from "./MasterDataTemplateEditor";

const MasterDataTemplateViewer = ({ file }) => {
  const [templateData, setTemplateData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTemplate = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/masterdata/${file.id}`);
      setTemplateData(data);
    } catch (err) {
      setError("Failed to load master data template.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!templateData) return null;

  return <MasterDataTemplateEditor file={file} templateData={templateData} setTemplateData={setTemplateData} />;
};

export default MasterDataTemplateViewer;
